import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=b04a7234&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b04a7234')) {
      api.createRecord('b04a7234', component.options)
    } else {
      api.reload('b04a7234', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=b04a7234&", function () {
      api.rerender('b04a7234', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2M9bl5iNKbb38/JS/comp/ErrorMessage.vue"
export default component.exports